import { Link } from 'react-router-dom';
import { getPopularArticles } from '@/mocks/articles';

export default function ArticleSection() {
  const popularArticles = getPopularArticles(6);

  return (
    <section className="py-14 bg-background-100">
      <div className="container-main">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl font-bold text-foreground-900">最新资讯</h2>
            <p className="text-sm text-foreground-500 mt-1">影视动态、行业观察、深度解读</p>
          </div>
          <Link
            to="/"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {popularArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-background-300 transition-all duration-300"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded">
                    {article.category === 'movies' ? '电影' :
                     article.category === 'tv' ? '电视剧' :
                     article.category === 'variety' ? '综艺' :
                     article.category === 'anime' ? '动漫' :
                     article.category === 'documentary' ? '纪录片' : '平台'}
                  </span>
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{(article.views / 10000).toFixed(0)}万 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}